import React from 'react';
import styled, { allowPropsAndIntrinsics } from '@tanium/react-emotion';
import {
  border,
  borderRadius,
  BorderRadiusStyleProps,
  BorderStyleProps,
  color,
  ColorStyleProps,
  space,
  SpaceStyleProps,
  sxCompose,
} from '@tanium/style-system';
import { Background } from './themeDefinitions';

export interface Props
  extends BorderStyleProps,
    BorderRadiusStyleProps,
    ColorStyleProps,
    SpaceStyleProps {
  /**
   * The well's contents.
   */
  children: React.ReactNode;
  /**
   * A class to apply to the Well. This prop should not generally be used and may have
   * unpredictable results; prefer using other props to customize the appearance of the Well
   * instead.
   */
  className?: string;
}

const StyledWell = styled('div', {
  shouldForwardProp: allowPropsAndIntrinsics(['children', 'className']),
})(sxCompose(space, border, borderRadius, color));

/**
 * A simple styled container for arbitrary content.
 */
export const Well = React.forwardRef<HTMLDivElement, Props>(
  ({ p = 2, padding = p, ...props }, ref) => (
    <StyledWell ref={ref} padding={padding} bg={Background} borderRadius={1} {...props} />
  ),
);
